import React from 'react';

// Shared daily navigation: keep sport pages and the combined view identical.
export default function DateNavigation({label, isToday, onPrevious, onNext, onToday, nextDisabled}) {
  return <div className="date-navigation">
    <button className="date-arrow" onClick={onPrevious} aria-label="Föregående dag">‹</button>
    <span className="date-display"><span>{label}</span>{isToday && <small>Idag</small>}</span>
    <button className="date-arrow" onClick={onNext} disabled={nextDisabled} aria-label="Nästa dag">›</button>
    {!isToday && <button onClick={onToday} className="today-button">Idag</button>}
  </div>;
}
